export default {
  configurations: {},
  draftConfiguration: null,
  saveInProgress: false,
}
